import debounce from 'lodash/debounce';
import { runSmartSubnav } from '../../snippets/smart-subnav/smart-subnav';
import { initSecondGenerationControlProduct } from '../../snippets/product-base-second-generation-control/product-base-second-generation-control';
import { setMaxHeightStyle } from '../../scripts/utils/setMaxHeightStyle';
import YTPlayer from '../../scripts/components/YTPlayer';
import { initSmartHomeMobileSlider } from '../common/product-control-smart-home/product-control-smart-home';
import { initInstallationSlider } from '../../snippets/installation-slider/installation-slider';
import { initCollapsibleRows } from '../../snippets/collapsible-rows/collapsible-rows';

runSmartSubnav({
  intersectionThreshold: [0, 0.2],
  intersectionRatio: 0.2,
});

const initCollapsibleSecondGenerationControlTechSpecsMenu = () => {
  const setMaxHeightToEls = () => {
    setMaxHeightStyle('[data-product-control-tech-specs-collapsible-content]');
  };

  window.addEventListener('load', setMaxHeightToEls);

  window.addEventListener('resize', debounce(setMaxHeightToEls, 50));
};

initSecondGenerationControlProduct();
initSmartHomeMobileSlider();
initInstallationSlider();
YTPlayer.init();
initCollapsibleRows();
initCollapsibleSecondGenerationControlTechSpecsMenu();
